import InformationBanner from './information-banner';
import './information-banner.scss';

export default InformationBanner;
